<template> 
  <div class="link"> 
 <a :href="'https://www.google.com/maps/search/?api=1&output=embed&query='+data.centerLat+','+data.centerLng"  target="_blank">{{data.centerLat+','+data.centerLng}}</a>

  </div> 
</template> 


<script>


export default {
  data () {
    return {
      data:{}
    }
  }
       
}
</script>